import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { AppConfigService } from './base/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class HomeApprovalService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
  
  private completeApprovalResponse: any = null;
  private completeRePumpApprovalResponse: any = null;
  
  constructor(private http: HttpClient) {
  }
  
  /**
   * Gets the current facility ID from localStorage or returns default 'ES'
   */
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }
  
getHomeData(tagNumber: string, facilityId: string = ''): Observable<any> {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();
    
    return this.http.get(`${this.apiBaseUrl}Approval/GetData?facility=${currentFacilityId}&tag=${encodeURIComponent(tagNumber)}`).pipe(
      catchError(error => {
        
        return of([]); // Return empty array instead of throwing error
      })
    )
  }
  getHomeApprovalData(tagNumber: string, facilityId: string = '', skipResponseSave: boolean = false): Observable<any> {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();
    
    const response = this.http.get(`${this.apiBaseUrl}Approval/GetApproval?facilityId=${currentFacilityId}&tagNumber=${encodeURIComponent(tagNumber)}`).pipe(
      catchError(error => {
        
        return of([]); // Return empty array instead of throwing error
      })
    )
    
    // Save the complete response for later use (unless skipResponseSave is true)
    if (!skipResponseSave) {
      response.subscribe(data => {
        this.completeApprovalResponse = data;
      });
    }
    
    return response;
  }
    getHomeRePumpApprovalData(tagNumber: string, facilityId: string = '', skipResponseSave: boolean = false): Observable<any> {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();
    
    const response = this.http.get(`${this.apiBaseUrl}Approval/GetRePumpApproval?facilityId=${currentFacilityId}&tagNumber=${encodeURIComponent(tagNumber)}`).pipe(
      catchError(error => {
        
        return of([]); // Return empty array instead of throwing error
      })
    )
    
    // Save the complete response for later use (unless skipResponseSave is true)
    if (!skipResponseSave) {
      response.subscribe(data => {
        this.completeRePumpApprovalResponse = data;
      });
    }
    
    return response;
  }
  
  // Method to access the complete approval response object including button visibility flags
  getApprovalResponse(): any {
    return this.completeApprovalResponse;
  }
  
  // Method to access the complete repump approval response object including button visibility flags
  getRePumpApprovalResponse(): any {
    return this.completeRePumpApprovalResponse;
  }
  postRempumpApprovaSave(repumpApprovalData: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/SaveRepumpApproval`, repumpApprovalData).pipe(
      catchError(error => {
        console.error("Error saving repump approval:", error);
        throw error; // Re-throw the error to be handled by the component
      })
    );
  }
  saveChangesOnPostApproval(approvalData: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/SaveApproval`, approvalData).pipe(
      catchError(error => {
        console.error("Error saving changes on post approval:", error);
        throw error; // Re-throw the error to be handled by the component
      })
    );
  }

    deleteApprovalRecordId(recId : any,tagNumber: string): Observable<any> {
      return this.http.delete(`${this.apiBaseUrl}Approval?id=${recId}&facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`);
    }

        deleteRePumpApprovalRecordId(recId : any,tagNumber: string): Observable<any> {
      return this.http.delete(`${this.apiBaseUrl}Approval/DeleteRePumpApproval?id=${recId}&facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`);
    }
    
  approveRowDataInApproval(recId:any,tagNumber: string,cai:string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/Approve?id=${recId}&facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`, {}).pipe(
      catchError(error => { 
        return of({ success: false, error: error.message || 'Command execution failed' });
      })
    );
  }

  reSendApprovalEmail(tagNumber: string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/ReSendApprovalEmail?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`, {}).pipe(
      catchError(error => { 
        return of({ success: false, error: error.message || 'Command execution failed' });
      })
    );
  }



 reSendRepumpApprovalEmail(tagNumber: string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/ReSendRePumpApprovalEmail?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}&cai=qwlx`, {}).pipe(
      catchError(error => { 
        return of({ success: false, error: error.message || 'Command execution failed' });
      })
    );
  }
  reOpenApproval(tagNumber: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/ReOpenApproval?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`, {}).pipe(
      catchError(error => {
        console.error("Error reopening approval:", error);
        throw error; // Re-throw the error to be handled by the component
      })
    );
  }
  rePumpReopenOpenApproval(tagNumber: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/ReOpenRePumpApproval?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`, {}).pipe(
      catchError(error => {
        console.error("Error reopening approval:", error);
        throw error; // Re-throw the error to be handled by the component
      })
    );
  }

   approveRowDataInRepumpApproval(recId:any,tagNumber: string,cai:string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Approval/UpdateRePumpApproval?id=${recId}&facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}&cai=${cai}`, {}).pipe(
      catchError(error => { 
        return of({ success: false, error: error.message || 'Command execution failed' });
      })
    );
  }
}

